import { render, staticRenderFns } from "./CoverDetails.vue?vue&type=template&id=3d67806c&"
import script from "./CoverDetails.vue?vue&type=script&lang=js&"
export * from "./CoverDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports